import gql from 'graphql-tag';

export const UPDATE_USER_MUTATION = gql`
  mutation UpdateUser($id: Int!, $input: UpdateUserInput!) {
    updateUser(id: $id, input: $input) {
      id
      email
      name
      firstName
      lastName
      communicationPreferences
    }
  }
`;

export const EMAIL_EXISTS_QUERY = gql`
  query emailExists($email: String!) {
    userExists(email: $email)
  }
`;

export const updateUserMock = {
  updateUser: {
    email: 'bertha.brownbags@ap.com',
    firstName: 'Bertha',
    id: 10,
    lastName: 'Brownbags',
    name: 'Bertha Brownbags',
    communicationPreferences: ['transactional_sms'],
  },
};

export const emailExistsMock = {
  userExists: false,
};
